/**
 * Created by vladislav on 04/04/2022
 */

const CaravanMissionWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;

        this._super({
            name: "CaravanMissionWindow",
            content: this.createContent(),
            noBackground: true,
            title: Messages.get("CaravanMissionWindow.Title"),
            notCloseByTouchInShadow: true,
            closeButtonDelay: true
        });

        cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");
    },

    getPerson: function () {
        return {
            left: cleverapps.persons.choose("seller", "camel"),
            right: "camel"
        };
    },

    createContent: function () { 
        const styles = cleverapps.styles.CaravanMissionWindow;

        const productViews = ["caravan0", "caravan1", "caravan2"].map(function (productId, index) {
            const product = Product.CreateById(productId);
            const cupData = Families.caravanbox.units[index].cup;

            const tileView = new CaravanTileView(product, cupData, this.buyProduct.bind(this, product));
            tileView.setLocalZOrder(-index);

            return tileView;
        }, this);

        productViews.forEach((view, index) => {
            view.runAction(new cc.Sequence(
                new cc.DelayTime(0.7 + 0.3 * index),
                new cc.CallFunc(() => {
                    view.onHelpButtonClicked();
                })
            ));
        });

        return new cleverapps.Layout(productViews, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
    },

    buyProduct: function (reward) {
        this.mission.logic.buyProduct(reward);

        this.close();
    },

    listBundles: function () {
        return ["caravan"];
    }
});

cleverapps.styles.CaravanMissionWindow = {
    margin: 20
};
